<template>
	<div class="sp">
		<div class="sp__elm">
			<!-- /////////////////// -->
			<!-- INPUT current password -->
			<div class="sp__elm-item">
				<!-- LABEL -->
				<div class="sp__elm-item-label">Текущий пароль:</div>
				<!-- INPUT -->
				<div class="sp__elm-item-input">
					<input
						type="password"
						class="sp__elm-item-input-password"
						placeholder="Введите пароль"
					/>
				</div>
			</div>

			<!-- /////////////////// -->
			<!-- INPUT new password -->
			<div class="sp__elm-item">
				<!-- LABEL -->
				<div class="sp__elm-item-label">Новый пароль:</div>
				<!-- INPUT -->
				<div class="sp__elm-item-input">
					<input
						type="password"
						class="sp__elm-item-input-password"
						placeholder="Введите пароль"
					/>
				</div>
			</div>

			<!-- /////////////////// -->
			<!-- INPUT new password -->
			<div class="sp__elm-item">
				<!-- LABEL -->
				<div class="sp__elm-item-label">Новый пароль ещё раз:</div>
				<!-- INPUT -->
				<div class="sp__elm-item-input">
					<input
						type="password"
						class="sp__elm-item-input-password"
						placeholder="Введите пароль"
					/>
				</div>
			</div>

			<!-- Разделительная линия -->
			<div class="sp__elm-line"></div>

			<!-- /////////////////// -->
			<!-- FOOTER -->
			<div class="sp__elm-item">
				<!-- BUTTON - Изменить пароль -->
				<div class="sp__elm-item-btn">
					<UiButton
						label="Изменить пароль"
						background-color="var(--theme-color)"
						border-color="var(--theme-color)"
						color="rgb(255, 255, 255)"
						font-weight="600"
						font-size="16px"
					/>
				</div>

				<!-- Выйти -->
				<div class="sp__elm-item-exit">
					<IconExit color="rgb(119, 121, 124)" />
					<div class="sp__elm-item-exit-label">Выйти</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import UiButton from "@/components/ui/UiButton.vue";
import IconExit from "@/components/icons/IconExit.vue";

@Options({
	components: { IconExit, UiButton },
})
export default class SettingProfile extends Vue {}
</script>

<style scoped lang="scss">
.sp {
	&__elm {
		padding: 24px;
		background: rgb(255, 255, 255);
		border-radius: 12px;
		box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);
	}

	&__elm-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 12px;
	}

	&__elm-item-btn {
		display: flex;
		padding-top: 12px;
	}

	&__elm-item-exit {
		display: flex;
		align-items: center;
		padding-top: 12px;
	}

	&__elm-item-exit-label {
		color: rgb(49, 49, 50);
		font-size: 16px;
		margin-left: 10px;
		cursor: pointer;
	}

	&__elm-item-label {
		color: rgb(49, 49, 50);
	}

	&__elm-item-input {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		border: 1px solid rgb(244, 246, 250);
		border-radius: 12px;
		padding: 8px 12px 8px 12px;
		background-color: rgb(244, 246, 250);
		min-width: 300px;
	}

	&__elm-item-input-password {
		background-color: rgb(244, 246, 250);
		border: 1px solid rgb(244, 246, 250);
		font-size: 16px;
		width: 90%;
	}

	&__elm-item-input-password:focus {
		outline-color: rgb(244, 246, 250);
		outline-style: solid;
	}

	&__elm-line {
		padding-top: 24px;
		border-bottom: 1px solid rgb(223, 230, 238);
	}

	@media screen and (max-width: 768px) {
		&__elm {
			padding: 12px;
		}

		&__elm-item {
			display: block;
			flex-direction: column;
			align-items: flex-start;
		}

		&__elm-item-input {
			min-width: 10px;
		}

		&__elm-item-label {
			padding-bottom: 8px;
			color: rgb(49, 49, 50);
			font-size: 14px;
		}

		&__elm-item-btn {
			display: block;
		}

		&__elm-item-exit {
			padding: 24px 0 12px;
			justify-content: center;
		}
	}
}
</style>
